<!-- Internship experiences - 实习经验 -->
<template>
  <div class="info-internship">
    <h1>Internship experiences</h1>
    <div class="dis-96" v-for="(item,index) in info.workExperiences" :key="index">
      <h2>Internship experiences 0{{index+1}}</h2>
      <ul class="ul-item dis-24">
        <li>
          <div>Firm</div>
          <div>{{item.name}}</div>
        </li>
        <li>
          <div>Division</div>
          <div>{{item.division}}</div>
        </li>
        <li>
          <div>Role Title</div>
          <div>{{item.title}}</div>
        </li>
        <li>
          <div>Start Date</div>
          <div>{{item.startDate}}</div>
        </li>
        <li>
          <div>Time Commitment</div>
          <div>{{item.duration}}</div>
        </li>
      </ul>
      <div class="dis-24">
        <div class="dis-12">Any specific achievements / projects / notable things about your experience</div>
        <div>
          <pre>{{item.description}}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { infoQueryInternship } from '@/api/mentee'
export default {
  name: 'mentee-info-internship',
  components: {},
  data () {
    return {
      info: { }
    }
  },
  computed: {},
  mounted () { this.getInfo() },
  methods: {
    getInfo () {
      let param = {
        num: this.$route.params.id
      }
      infoQueryInternship(param).then(res => {
        let data = res.data.model || {}
        this.info = Object.assign({}, data)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
